import {
  Component,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { S3_URL_BASE } from 'src/environments/environment';
import { InputFileWithCommentCommentComponent } from './input-file-with-comment-comment/input-file-with-comment-comment.component';

@Component({
  selector: 'app-input-file-with-comment',
  templateUrl: './input-file-with-comment.component.html',
  styleUrls: ['./input-file-with-comment.component.sass'],
})
export class InputFileWithCommentComponent implements OnInit, OnDestroy {
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;

  @Input()
  mask: string;

  @Input()
  typeCes?: TypeCesEnum | undefined;

  formSub: Subscription;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.formSub = this.group.valueChanges.subscribe((value) => {
      if (!(value[this.config.name] instanceof File))
        this.fileName = value[this.config.name];
    });
  }

  ngOnDestroy(): void {
    this.formSub?.unsubscribe();
  }

  get typeCesEnum() {
    return TypeCesEnum;
  }

  get messagesEnum() {
    return MessagesEnum;
  }

  @Input()
  requiredFileType: string;

  fileName = '';
  uploadProgress: number;
  uploadSub: Subscription;

  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.fileName = file.name;
      this.group.get(this.config.name)?.setValue(file);
    }

    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: InputFileWithCommentCommentComponent,
      data: {
        type: TypeCesEnum.EDIT,
        element: this.group.get(`${this.config.name}Comment`)?.value,
      },
      callBack: async (data: any) => {
        if (data?.element) {
          this.group.get(`${this.config.name}Comment`)?.setValue(data.element);
        }
      },
    });
  }

  getFileUri() {
    return `${S3_URL_BASE}${this.group.get(this.config.name)?.getRawValue()}`;
  }

  public cancelFile() {
    this.fileName = '';
    this.group.get(this.config.name)?.setValue('');
  }

  public downloadFile() {
    return `${S3_URL_BASE}${this.group.get(this.config.name)?.getRawValue()}`;
  }

  public getComment() {
    return this.group.get(`${this.config.name}Comment`)?.value;
  }
}
